import { CharacterCard } from "@next-platform/client-common-spicy-ui";
import { useMemo } from "react";

import { CharacterCardProps } from "@/components/Character/CharacterCard/types";
import { AvatarPreset } from "@/types";
import { getAvatarUrl } from "@/utils";

const DEFAULT_AVATAR_PRESET = AvatarPreset.AVATAR_256X256;

/**
 * Default character card variant.
 *
 * Wraps the upstream `CharacterCard` and resolves `characterInfo.characterAvatarUrl`
 * (raw character `avatar_url`) into a CDN-optimized URL with the preset best suited
 * for this variant's visual design. Each variant owns its own preset, so callers
 * pass the raw URL and never need brand-aware preset logic.
 */
const CharacterCardDefault = (props: CharacterCardProps) => {
  const { characterInfo } = props;
  const resolvedCharacterInfo = useMemo(
    () => ({
      ...characterInfo,
      characterAvatarUrl: getAvatarUrl(characterInfo.characterAvatarUrl ?? "", { preset: DEFAULT_AVATAR_PRESET }) ?? "",
    }),
    [characterInfo],
  );
  return <CharacterCard data-testid="character-card-default" {...props} characterInfo={resolvedCharacterInfo} />;
};

export default CharacterCardDefault;
